// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"acca0757","963":"631f76dd"}[chunkId] + ".chunk.js";
};